import React from 'react';
import { Switch, withRouter, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import RoutesAuthorizationChecker from 'auth/RoutesAuthorizationChecker';
import ConnectedAuthenticatedRoute from 'auth/ConnectedAuthenticateRoute';
import NotFoundPage from 'legacy/pages/NotFoundPage';
import routes from '../routes';

const RouteManager = props => (
  <RoutesAuthorizationChecker {...props}>
    <Switch>
      {routes.map(route => {
        if (route.redirect) {
          return <Redirect key={`${route.from}-${route.to}`} {...route} />;
        }
        if (route.authenticatedRoute) {
          return (
            <ConnectedAuthenticatedRoute
              key={route.path}
              {...props}
              {...route}
            />
          );
        }

        return <Route key={route.path} {...route} />;
      })}

      {/* Fallback 404 */}
      <Route component={NotFoundPage} />
    </Switch>
  </RoutesAuthorizationChecker>
);

export default withRouter(
  connect(
    state => ({
      authorizationType: state.auth.authorizationType,
    }),
    dispatch => ({
      dispatch,
    }),
  )(RouteManager),
);



// WEBPACK FOOTER //
// ./src/views/RouteManager.jsx